module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-1"
  }, [_c('div', {
    staticClass: "timeline timeline-left"
  }, [_c('div', {
    staticClass: "timeline-container"
  }, [_c('new-item-block', {
    on: {
      "itemAdded": _vm.addItem
    }
  }), _vm._v(" "), _vm._l((_vm.filterItems), function(it) {
    return _c('note-item', {
      key: it['.key'],
      attrs: {
        "timeline": true,
        "item": it
      },
      on: {
        "itemRemoved": _vm.removeItem
      }
    })
  })], 2)])]), _vm._v(" "), _c('pagination', {
    attrs: {
      "pagesCount": _vm.pagesCount,
      "current": _vm.current,
      "onPageChange": _vm.onPageChange
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8e8b6ca","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
// module id = 366
// module chunks = 0